// assets
import { IconDashboard, IconBuildingArch, IconUser } from '@tabler/icons-react';

// constant
const icons = { IconDashboard, IconBuildingArch, IconUser };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
    {
      id: 'action',
      title: 'Action',
      type: 'item',
      url: '/dashboard/action',
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
    {
      id: 'allAction',
      title: 'All Actions',
      type: 'item',
      url: '/dashboard/all-actions',
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
    {
      id: 'department',
      title: 'Department',
      type: 'item',
      url: '/dashboard/department',
      icon: icons.IconBuildingArch,
      breadcrumbs: false,
    },
    {
      id: 'user',
      title: 'User',
      type: 'item',
      url: '/dashboard/user',
      icon: icons.IconUser,
      breadcrumbs: false,
    },
  ],
};

export const dashboardDept = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
    {
      id: 'department-action',
      title: 'Department Action',
      type: 'item',
      url: '/dashboard/department-action',
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
  ],
};
